import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Button, Card, CardContent } from '@mui/material';
import { CheckCircle, Error, FitnessCenter } from '@mui/icons-material';
import axios from 'axios';

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('');
    const hasVerified = useRef(false); // ✅ Sprechи double call

    useEffect(() => {
        if (hasVerified.current) return; // ✅ Ako vec e povikan, ne povikuvaj povtorno
        hasVerified.current = true;

        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('Невалиден линк.');
            return;
        }
        verifyToken(token);
    }, []);

    const verifyToken = async (token) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/verify-email?token=${token}`);
            setStatus('success');
            setMessage(res.data.message);
        } catch (err) {
            const data = err.response?.data;
            if (data?.expired) {
                setStatus('expired');
            } else {
                setStatus('error');
            }
            setMessage(data?.message || 'Грешка при верификација.');
        }
    };

    return (
        <Box sx={{
            minHeight: '100vh', display: 'flex', alignItems: 'center',
            justifyContent: 'center', backgroundColor: '#fafafa', p: 2
        }}>
            <Card sx={{
                maxWidth: 480, width: '100%', borderRadius: '20px',
                border: '2px solid #ff7eb9',
                boxShadow: '0 8px 32px rgba(255,126,185,0.2)',
                backgroundColor: '#ffffff'
            }}>
                <CardContent sx={{ p: 5, textAlign: 'center' }}>
                    <FitnessCenter sx={{ fontSize: 50, color: '#ff7eb9', mb: 2 }} />

                    {status === 'loading' && (
                        <>
                            <CircularProgress sx={{ color: '#ff7eb9', mb: 2 }} />
                            <Typography variant="h6" sx={{ color: '#333' }}>
                                Се верифицира...
                            </Typography>
                        </>
                    )}

                    {status === 'success' && (
                        <>
                            <CheckCircle sx={{ fontSize: 64, color: '#4CAF50', mb: 2 }} />
                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#4CAF50', mb: 1 }}>
                                ✅ Успешно верифицирано!
                            </Typography>
                            <Typography sx={{ color: '#666', mb: 3 }}>
                                {message}
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/login')}
                                sx={{
                                    background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                                    borderRadius: '12px', px: 4, fontWeight: 'bold',
                                    '&:hover': { transform: 'translateY(-2px)' }
                                }}>
                                🔐 Оди на Најава
                            </Button>
                        </>
                    )}

                    {(status === 'error' || status === 'expired') && (
                        <>
                            <Error sx={{ fontSize: 64, color: '#f44336', mb: 2 }} />
                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#f44336', mb: 1 }}>
                                {status === 'expired' ? '⏰ Линкот е истечен' : '❌ Невалиден линк'}
                            </Typography>
                            <Typography sx={{ color: '#666', mb: 3 }}>
                                {message}
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/register')}
                                sx={{
                                    background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                                    borderRadius: '12px', px: 4, fontWeight: 'bold',
                                    '&:hover': { transform: 'translateY(-2px)' }
                                }}>
                                📝 Регистрирај се повторно
                            </Button>
                        </>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default VerifyEmail;